module.exports = __webpack_public_path__ + "img/no-records-admin-invites.1950c147.png";